export enum RxStatusEnum {
	Unscanned = 'Unscanned',
	Scanned = 'Scanned',
	Sent = 'Sent'
}